<template>
  <app-dropdown-button>
    <template #left-icon>
      <app-icon-ds
        icon="plus"
        size="xs"
        weight="fas"
      />
    </template>
    {{ $t('common.add') }}

    <template #list>
      <v-list data-locator="checklist-add-menu">
        <app-dropdown-button-item
          data-locator="add-task-menu-item"
          :disabled="createTaskPending"
          icon="check-square"
          :label="t('addTask')"
          @click="createTask"
        />

        <app-dropdown-button-item
          data-locator="add-section-menu-item"
          :disabled="createSectionPending"
          icon="heading"
          :label="t('addSection')"
          @click="createSection"
        >
          <template #icon>
            <app-icon-ds
              icon="regular-checklist-section"
              size="sm"
              weight="fak"
            />
          </template>
        </app-dropdown-button-item>

        <template v-if="isSubscriber">
          <v-divider />

          <app-dropdown-button-item 
            data-locator="template-import-menu-item"
            icon="table-layout"
            :label="t('addFromTemplate')"
            @click="onImportChecklistFromTemplate"
          />

          <app-dropdown-button-item
            data-locator="excel-import-menu-item"
            icon="file-excel"
            :label="t('importFromExcel')"
            @click="onImportChecklistClick"
          >
            <template #icon>
              <OfficeIcon
                class="excel-icon"
                document-type="excel"
                :height="16"
                icon-type="product"
                :width="16"
              />
            </template>
          </app-dropdown-button-item>
        </template>
      </v-list>
    </template>
  </app-dropdown-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import OfficeIcon from '@/common/office/OfficeIcon.vue'
import { toast } from '@/common/utils/toast'
import { useTranslation } from '@/common/utils/translation'
import { CREATE_TASK, CREATE_SECTION } from '@/store/modules/checklist/action_types'
import {
  SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN,
  SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN,
} from '@/store/modules/checklist/mutation_types'

export default defineComponent({
  name: 'ChecklistAddButton',
  components: { OfficeIcon },
  setup () {
    return useTranslation({ keyPrefix: 'project.checklist.ChecklistAddButton' })
  },
  computed: {
    ...mapState('checklist', ['createSectionPending', 'createTaskPending']),
    ...mapGetters('checklist', ['flatChecklist']),
    ...mapGetters('user', ['isSubscriber']),
    ...mapGetters('room', ['roomMnemo']),
  },
  methods: {
    ...mapActions('checklist', [CREATE_TASK, CREATE_SECTION]),
    ...mapMutations('checklist', [
      SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN,
      SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN,
    ]),
    async createTask () {
      try {
        const data = {
          prevId: null,
          prevType: null,
        }
        if (this.flatChecklist.length > 0) {
          const lastElement = this.flatChecklist[this.flatChecklist.length - 1]
          data.prevId = lastElement.id
          data.prevType = lastElement.type
        }
        await this.CREATE_TASK({
          mnemo: this.roomMnemo,
          data,
        })
        toast.success(this.t('createTaskSuccess'))
      } catch (e) {
        toast.error(this.t('createTaskError'))
      }
    },
    async createSection () {
      try {
        const data = {
          title: '',
          depth: 0,
          prevId: null,
          prevType: null,
        }
        if (this.flatChecklist.length > 0) {
          const lastElement = this.flatChecklist[this.flatChecklist.length - 1]
          data.prevId = lastElement.id
          data.prevType = lastElement.type
        }
        await this.CREATE_SECTION({
          mnemo: this.roomMnemo,
          data,
        })
        toast.success(this.t('createSectionSuccess'))
      } catch (e) {
        toast.error(this.t('createSectionError'))
      }
    },
    onImportChecklistFromTemplate () {
      this.SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN(true)
    },
    onImportChecklistClick () {
      this.SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN(true)
    },
  },
})
</script>
